import {
  electrical,
  plumbing,
  appliance,
  exterior,
  interior,
  other1,
  insurance,
  payroll,
  tax,
  violation
} from "../../assets";

const ServiceIcon = ({ serviceType }) => {
  const serviceTypeToImagePath = {
    Plumbing: plumbing,
    Appliance: appliance,
    Other: other1,
    Exterior: exterior,
    Interior: interior,
    Electrical: electrical,
    Insurance: insurance,
    Payroll: payroll,
    Tax: tax,
    Violation: violation

  };
  const imagePath = serviceTypeToImagePath[serviceType];
  const path = imagePath ? imagePath : other1;

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minWidth: 50,
        minHeight: 50
      }}
    >
      <img
        src={path}
        alt={`${serviceType} icon`}
        style={{ width: "30px", height: "30px", flexShrink: 0 }}
        className="color-white-icon"
      />
    </div>
  );
};

export default ServiceIcon;

